import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "grid min-h-0 flex-1 grid-cols-1 gap-6 lg:grid-cols-12"
};
const _hoisted_2 = {
  class: "lg:col-span-3"
};
const _hoisted_3 = {
  class: "flex min-h-0 flex-col lg:col-span-9"
};
const _hoisted_4 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_5 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_6 = {
  class: "data-table-shell"
};
const _hoisted_7 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_8 = {
  key: 0,
  class: "divide-y divide-slate-100"
};
const _hoisted_9 = {
  key: 1,
  class: "empty-state"
};
const _hoisted_10 = {
  key: 2,
  class: "divide-y divide-slate-100"
};
const _hoisted_11 = {
  key: 0,
  class: "h-20 w-32 shrink-0 overflow-hidden rounded-lg bg-slate-100"
};
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = {
  class: "flex min-w-0 flex-1 flex-col justify-between"
};
const _hoisted_14 = {
  class: "flex items-center gap-2"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  key: 0,
  class: "status-badge shrink-0 is-warning"
};
const _hoisted_17 = {
  key: 0,
  class: "data-table-cell-meta mt-1 line-clamp-1"
};
const _hoisted_18 = {
  class: "data-table-cell-meta mt-2 flex items-center gap-4"
};
const _hoisted_19 = {
  class: "flex items-center gap-1"
};
const _hoisted_20 = {
  class: "flex items-center gap-1"
};
const _hoisted_21 = {
  class: "flex items-center gap-1"
};
const _hoisted_22 = {
  class: "flex shrink-0 items-center gap-1"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_27 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_28 = {
  class: "flex items-center gap-3"
};
const _hoisted_29 = {
  class: "text-lg font-semibold text-white"
};
const _hoisted_30 = {
  class: "space-y-5 px-6 py-6"
};
const _hoisted_31 = {
  class: "space-y-1.5"
};
const _hoisted_32 = {
  class: "space-y-1.5"
};
const _hoisted_33 = {
  class: "space-y-5 px-6 py-6"
};
const _hoisted_34 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_35 = {
  class: "space-y-1.5"
};
const _hoisted_36 = {
  class: "space-y-1.5"
};
const _hoisted_37 = {
  class: "space-y-1.5"
};
const _hoisted_38 = {
  class: "flex justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4"
};
const _hoisted_39 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5 shrink-0"
};
const _hoisted_40 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_41 = {
  class: "flex items-center gap-3"
};
const _hoisted_42 = {
  class: "text-lg font-semibold text-white"
};
const _hoisted_43 = {
  class: "mt-0.5 text-sm text-primary-100"
};
const _hoisted_44 = {
  class: "overflow-y-auto flex-1 px-6 py-6"
};
const _hoisted_45 = {
  class: "space-y-5"
};
const _hoisted_46 = {
  class: "grid grid-cols-1 lg:grid-cols-2 gap-4"
};
const _hoisted_47 = {
  class: "space-y-1.5"
};
const _hoisted_48 = {
  class: "space-y-1.5"
};
const _hoisted_49 = {
  class: "space-y-1.5"
};
const _hoisted_50 = {
  class: "space-y-1.5"
};
const _hoisted_51 = {
  class: "space-y-1.5"
};
const _hoisted_52 = {
  class: "flex items-start gap-4"
};
const _hoisted_53 = {
  key: 0,
  class: "group relative h-24 w-40 overflow-hidden rounded-lg border border-slate-200"
};
const _hoisted_54 = ["src"];
const _hoisted_55 = {
  class: "absolute inset-0 flex items-center justify-center gap-3 bg-black/50 opacity-0 transition-opacity group-hover:opacity-100"
};
const _hoisted_56 = {
  class: "space-y-1.5"
};
const _hoisted_57 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_58 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_59 = {
  class: "overflow-y-auto max-h-[calc(90vh-100px)] px-6 py-6"
};
const _hoisted_60 = {
  key: 0,
  class: "space-y-4 animate-pulse"
};
const _hoisted_61 = {
  key: 0,
  class: "mb-5 overflow-hidden rounded-xl"
};
const _hoisted_62 = ["src", "alt"];
const _hoisted_63 = {
  class: "flex flex-wrap items-center gap-3"
};
const _hoisted_64 = {
  key: 0,
  class: "flex items-center gap-1 rounded-full status-badge is-warning px-2.5 py-1 text-xs font-medium"
};
const _hoisted_65 = {
  class: "mt-4 text-xl font-bold text-slate-900"
};
const _hoisted_66 = {
  key: 1,
  class: "mt-2 text-sm text-slate-600 leading-relaxed"
};
const _hoisted_67 = {
  class: "mt-4 flex items-center gap-4 text-xs text-slate-500"
};
const _hoisted_68 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_69 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_70 = {
  class: "mt-6"
};
const _hoisted_71 = {
  class: "rounded-xl border border-slate-200 bg-slate-50/50 p-5"
};
const _hoisted_72 = {
  class: "prose prose-sm max-w-none text-slate-700"
};
const _hoisted_73 = {
  class: "mt-6 flex flex-wrap items-center gap-4 rounded-xl border border-slate-100 bg-slate-50/50 px-4 py-3 text-xs text-slate-500"
};
const _hoisted_74 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_75 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_76 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_77 = {
  key: 0,
  class: "flex items-center gap-1.5"
};
const _hoisted_78 = {
  class: "relative"
};
const _hoisted_79 = ["src"];
const _hoisted_80 = {
  class: "flex flex-col items-center px-6 pt-8 pb-4"
};
const _hoisted_81 = {
  class: "mt-2 text-center text-sm text-slate-600 leading-relaxed"
};
const _hoisted_82 = {
  class: "flex gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4"
};
import { onMounted, onUnmounted, reactive, ref, computed } from 'vue';
import { ElMessage } from 'element-plus';
import KbCategoryTree from './components/KbCategoryTree.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import RichTextEditor from '@/components/RichTextEditor.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppPagination from '@/components/AppPagination.vue';
import { uploadFile } from '@/api/file';
import { formatDateTimeText } from '@/utils/dateFormat';
import { useKbCategoryManagement } from './composables/useKbCategoryManagement';
import AppModal from '@/components/AppModal.vue';
import ArticlePreviewModal from '@/components/ArticlePreviewModal.vue';
import { getArticleCategoryTree, createArticleCategory, updateArticleCategory, deleteArticleCategory, getArticlePage, getArticleDetail, createArticle, updateArticle, deleteArticle, publishArticle, offlineArticle, onlineArticle, toggleArticleTop } from '@/api/kb';

// ==================== 分类相关 ====================

export default {
  __name: 'ArticleManagement',
  setup(__props) {
    const categoryState = useKbCategoryManagement({
      loadCategoryTree: getArticleCategoryTree,
      createCategory: createArticleCategory,
      updateCategory: updateArticleCategory,
      defaultStatus: 0,
      includeRemark: true,
      messages: {
        loadError: '\u52a0\u8f7d\u5206\u7c7b\u5931\u8d25',
        emptyNameWarning: '\u8bf7\u8f93\u5165\u5206\u7c7b\u540d\u79f0',
        updateSuccess: '\u5206\u7c7b\u66f4\u65b0\u6210\u529f',
        createSuccess: '\u5206\u7c7b\u521b\u5efa\u6210\u529f',
        saveError: '\u4fdd\u5b58\u5206\u7c7b\u5931\u8d25'
      }
    });
    const categoryTree = categoryState.categoryTree;
    const categoryLoading = categoryState.categoryLoading;
    const selectedCategoryId = categoryState.selectedCategoryId;
    const showCategoryModal = categoryState.showCategoryModal;
    const isCategoryEdit = categoryState.isCategoryEdit;
    const categoryForm = categoryState.categoryForm;
    const loadCategories = categoryState.loadCategories;
    const flatCategories = categoryState.flatCategories;
    const getCategoryName = categoryState.getCategoryName;
    const getLastCategoryName = categoryState.getLastCategoryName;
    const handleCategorySelect = categoryState.handleCategorySelect;
    const handleAddCategory = categoryState.handleAddCategory;
    const handleAddChildCategory = categoryState.handleAddChildCategory;
    const handleEditCategory = categoryState.handleEditCategory;
    const closeCategoryModal = categoryState.closeCategoryModal;
    const submitCategory = categoryState.submitCategory;
    const articleList = ref([]);
    const listLoading = ref(false);
    const searchKeyword = ref('');
    const searchStatus = ref('');
    const pageSize = ref(20);
    const pageInfo = reactive({
      current: 1,
      total: 0,
      hasPrevious: false,
      hasNext: false
    });
    const loadArticleList = async (page = 1) => {
      listLoading.value = true;
      try {
        const params = {
          page,
          size: pageSize.value,
          categoryId: selectedCategoryId.value || undefined,
          keyword: searchKeyword.value || undefined,
          status: searchStatus.value === '' ? undefined : Number(searchStatus.value)
        };
        const data = await getArticlePage(params);
        articleList.value = data.records || [];
        Object.assign(pageInfo, {
          current: data.current || 1,
          total: data.total || 0,
          hasPrevious: data.hasPrevious,
          hasNext: data.hasNext
        });
      } catch (error) {
        ElMessage.error(error.message || '加载资讯列表失败');
      } finally {
        listLoading.value = false;
      }
    };
    const handleCategoryTreeSelect = id => {
      handleCategorySelect(id, () => loadArticleList(1));
    };
    const handlePageChange = page => {
      loadArticleList(page);
    };
    const handlePageSizeChange = size => {
      pageSize.value = size;
      loadArticleList(1);
    };
    const statusText = status => ({
      0: '草稿',
      1: '已发布',
      2: '已下架'
    })[status] || '未知';
    const statusClass = status => ({
      0: 'status-badge is-neutral',
      1: 'status-badge is-success',
      2: 'status-badge is-warning'
    })[status] || 'status-badge is-neutral';

    // ==================== 图片URL处理 ====================
    const getImageUrl = url => {
      if (!url) return '';
      if (/^https?:\/\//i.test(url)) return url;
      return `${process.env.VUE_APP_API_BASE_URL || ''}/${url}`.replace(/\/+/g, '/').replace(':/', '://');
    };

    // ==================== 资讯表单弹窗 ====================
    const showFormModal = ref(false);
    const isEdit = ref(false);
    const coverInput = ref(null);
    const pendingCoverFile = ref(null);
    const coverPreviewUrl = ref('');
    const showCoverPreview = ref(false);
    const coverModified = ref(false);
    const articleForm = reactive({
      id: null,
      categoryId: '',
      title: '',
      author: '',
      summary: '',
      content: '',
      coverImage: ''
    });
    const coverDisplayUrl = computed(() => {
      if (coverPreviewUrl.value) return coverPreviewUrl.value;
      if (articleForm.coverImage) return getImageUrl(articleForm.coverImage);
      return '';
    });
    const openFormModal = async item => {
      pendingCoverFile.value = null;
      coverPreviewUrl.value = '';
      coverModified.value = false;
      if (item) {
        isEdit.value = true;
        try {
          const data = await getArticleDetail(item.id);
          Object.assign(articleForm, {
            id: data.id,
            categoryId: data.categoryId || '',
            title: data.title,
            author: data.author || '',
            summary: data.summary || '',
            content: data.content || '',
            coverImage: data.coverImage || ''
          });
        } catch (error) {
          ElMessage.error(error.message || '加载资讯详情失败');
          return;
        }
      } else {
        isEdit.value = false;
        Object.assign(articleForm, {
          id: null,
          categoryId: selectedCategoryId.value || '',
          title: '',
          author: '',
          summary: '',
          content: '',
          coverImage: ''
        });
      }
      showFormModal.value = true;
    };
    const closeFormModal = () => {
      showFormModal.value = false;
      if (coverPreviewUrl.value) {
        URL.revokeObjectURL(coverPreviewUrl.value);
        coverPreviewUrl.value = '';
      }
      pendingCoverFile.value = null;
    };
    const triggerCoverUpload = () => {
      coverInput.value?.click();
    };
    const handleCoverUpload = event => {
      const file = event.target.files?.[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        ElMessage.warning('请选择图片文件');
        event.target.value = '';
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        ElMessage.warning('图片大小不能超过5MB');
        event.target.value = '';
        return;
      }
      pendingCoverFile.value = file;
      coverModified.value = true;
      if (coverPreviewUrl.value) URL.revokeObjectURL(coverPreviewUrl.value);
      coverPreviewUrl.value = URL.createObjectURL(file);
      articleForm.coverImage = '';
      event.target.value = '';
    };
    const removeCover = () => {
      articleForm.coverImage = '';
      pendingCoverFile.value = null;
      coverModified.value = true;
      if (coverPreviewUrl.value) {
        URL.revokeObjectURL(coverPreviewUrl.value);
        coverPreviewUrl.value = '';
      }
    };
    const submitArticle = async () => {
      if (!articleForm.title.trim()) {
        ElMessage.warning('请输入资讯标题');
        return;
      }
      if (!articleForm.content || articleForm.content === '<p></p>') {
        ElMessage.warning('请输入资讯内容');
        return;
      }
      try {
        let coverImage = articleForm.coverImage;
        if (pendingCoverFile.value) {
          const res = await uploadFile(pendingCoverFile.value, 'article', 'public');
          const fileKey = res?.fileName || res?.data?.fileName;
          if (!fileKey) {
            ElMessage.error('封面上传失败，未获取到图片地址');
            return;
          }
          coverImage = fileKey;
        }
        const payload = {
          categoryId: articleForm.categoryId || undefined,
          title: articleForm.title,
          author: articleForm.author,
          summary: articleForm.summary,
          content: articleForm.content
        };
        if (!isEdit.value || coverModified.value) {
          payload.coverImage = coverImage;
        }
        if (isEdit.value) {
          await updateArticle(articleForm.id, payload);
          ElMessage.success('资讯更新成功');
        } else {
          await createArticle(payload);
          ElMessage.success('资讯创建成功');
        }
        closeFormModal();
        await loadArticleList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '保存资讯失败');
      }
    };

    // ==================== 资讯详情弹窗 ====================
    const showDetailModal = ref(false);
    const detailData = ref(null);
    const detailLoading = ref(false);
    const openDetailModal = async item => {
      showDetailModal.value = true;
      detailLoading.value = true;
      try {
        detailData.value = await getArticleDetail(item.id);
      } catch (error) {
        ElMessage.error(error.message || '加载详情失败');
      } finally {
        detailLoading.value = false;
      }
    };

    // ==================== 小程序预览 ====================
    const showMpPreviewModal = ref(false);
    const previewArticleId = ref(null);
    const previewArticleData = ref(null);

    // 列表入口：预览已保存资讯（走详情接口）
    const openMpPreview = id => {
      previewArticleData.value = null;
      previewArticleId.value = id;
      showMpPreviewModal.value = true;
    };

    // 表单入口：预览当前编辑内容（含未保存修改），封面按 getImageUrl 逻辑解析
    const openFormMpPreview = () => {
      previewArticleId.value = null;
      previewArticleData.value = {
        title: articleForm.title,
        author: articleForm.author,
        summary: articleForm.summary,
        content: articleForm.content,
        coverImage: coverDisplayUrl.value,
        categoryName: articleForm.categoryId ? getLastCategoryName(articleForm.categoryId) : ''
      };
      showMpPreviewModal.value = true;
    };

    // ==================== 操作 ====================
    const handlePublish = async item => {
      openMoreId.value = null;
      try {
        await publishArticle(item.id);
        ElMessage.success('发布成功');
        await loadArticleList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '发布失败');
      }
    };
    const handleOffline = async item => {
      openMoreId.value = null;
      try {
        await offlineArticle(item.id);
        ElMessage.success('已下架');
        await loadArticleList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '下架失败');
      }
    };
    const handleOnline = async item => {
      openMoreId.value = null;
      try {
        await onlineArticle(item.id);
        ElMessage.success('上架成功');
        await loadArticleList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '上架失败');
      }
    };
    const handleToggleTop = async item => {
      openMoreId.value = null;
      try {
        await toggleArticleTop(item.id);
        ElMessage.success(item.isTop ? '已取消置顶' : '已置顶');
        await loadArticleList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    };

    // ==================== 更多菜单 ====================
    const openMoreId = ref(null);
    const openMoreItem = ref(null);
    const moreMenuPos = reactive({
      top: 0,
      left: 0
    });
    const moreMenuStyle = computed(() => ({
      top: `${moreMenuPos.top}px`,
      left: `${moreMenuPos.left}px`
    }));
    const toggleMoreMenu = (id, event) => {
      if (openMoreId.value === id) {
        openMoreId.value = null;
        openMoreItem.value = null;
      } else {
        const item = articleList.value.find(a => a.id === id);
        openMoreItem.value = item;
        openMoreId.value = id;
        const btn = event.currentTarget;
        const rect = btn.getBoundingClientRect();
        moreMenuPos.top = rect.bottom + 4;
        moreMenuPos.left = rect.right - 160;
      }
    };
    const handleClickOutside = e => {
      if (openMoreId.value && !e.target.closest('.more-menu-container')) {
        openMoreId.value = null;
        openMoreItem.value = null;
      }
    };

    // ==================== 删除确认 ====================
    const showConfirmModal = ref(false);
    const confirmMessage = ref('');
    const confirmPayload = ref({
      type: '',
      id: null
    });
    const confirmDeleteCategory = node => {
      confirmPayload.value = {
        type: 'category',
        id: node.id
      };
      confirmMessage.value = `确认删除分类「${node.name}」？分类下的子分类和资讯将无法访问。`;
      showConfirmModal.value = true;
    };
    const confirmDeleteArticle = item => {
      openMoreId.value = null;
      confirmPayload.value = {
        type: 'article',
        id: item.id
      };
      confirmMessage.value = `确认删除资讯「${item.title}」？`;
      showConfirmModal.value = true;
    };
    const confirmDeleteAction = async () => {
      const {
        type,
        id
      } = confirmPayload.value;
      try {
        if (type === 'category') {
          await deleteArticleCategory(id);
          ElMessage.success('分类已删除');
          await loadCategories();
        } else {
          await deleteArticle(id);
          ElMessage.success('资讯已删除');
          await loadArticleList(pageInfo.current);
        }
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      } finally {
        showConfirmModal.value = false;
      }
    };

    // ==================== 初始化 ====================
    onMounted(async () => {
      document.addEventListener('click', handleClickOutside);
      await loadCategories();
      await loadArticleList(1);
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "资讯管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理平台资讯内容，支持分类管理、发布下架、置顶等操作。")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(KbCategoryTree, {
          tree: _unref(categoryTree),
          loading: _unref(categoryLoading),
          "selected-id": _unref(selectedCategoryId),
          title: "资讯分类",
          description: "按分类筛选资讯内容",
          onAdd: _unref(handleAddCategory),
          onEdit: _unref(handleEditCategory),
          onDelete: confirmDeleteCategory,
          onSelect: handleCategoryTreeSelect,
          onAddChild: _unref(handleAddChildCategory)
        }, null, 8, ["tree", "loading", "selected-id", "onAdd", "onEdit", "onAddChild"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": listLoading.value,
          onRefresh: _cache[7] || (_cache[7] = $event => loadArticleList(pageInfo.current))
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _cache[4] || (_cache[4] = $event => openFormModal()),
            class: "btn-primary"
          }, [...(_cache[38] || (_cache[38] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增资讯 ", -1)]))])), [[_directive_permission, 'kb:article:edit']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = $event => loadArticleList(1)),
            class: "btn-primary"
          }, "搜索"), _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = (...args) => _ctx.resetFilters && _ctx.resetFilters(...args)),
            class: "btn-secondary"
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
            onKeyup: _cache[1] || (_cache[1] = _withKeys($event => loadArticleList(1), ["enter"])),
            type: "text",
            placeholder: "搜索资讯标题或摘要...",
            class: "form-search-input form-control-sm w-full"
          }, null, 544), [[_vModelText, searchKeyword.value]]), _cache[37] || (_cache[37] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: searchStatus.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchStatus.value = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field",
            onChange: _cache[3] || (_cache[3] = $event => loadArticleList(1))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "草稿",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "已发布",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "已下架",
              value: "2"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [listLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
          return _createElementVNode("div", {
            key: n,
            class: "animate-pulse p-4"
          }, [...(_cache[39] || (_cache[39] = [_createElementVNode("div", {
            class: "flex gap-4"
          }, [_createElementVNode("div", {
            class: "h-20 w-32 shrink-0 rounded-lg bg-slate-200"
          }), _createElementVNode("div", {
            class: "flex-1 space-y-2"
          }, [_createElementVNode("div", {
            class: "h-5 w-3/4 rounded bg-slate-200"
          }), _createElementVNode("div", {
            class: "h-4 w-full rounded bg-slate-200"
          }), _createElementVNode("div", {
            class: "h-3 w-1/3 rounded bg-slate-200"
          })])], -1)]))]);
        }), 64))])) : !articleList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[41] || (_cache[41] = _createElementVNode("div", {
          class: "empty-state-icon"
        }, [_createElementVNode("svg", {
          class: "h-8 w-8",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
        })])], -1)), _cache[42] || (_cache[42] = _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无资讯数据", -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[8] || (_cache[8] = $event => openFormModal()),
          class: "btn-primary mt-4"
        }, [...(_cache[40] || (_cache[40] = [_createTextVNode("新增资讯", -1)]))])), [[_directive_permission, 'kb:article:edit']])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "data-table-row group flex gap-4 p-4 transition-colors"
          }, [item.coverImage ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("img", {
            src: getImageUrl(item.coverImage),
            alt: item.title,
            class: "h-full w-full object-cover"
          }, null, 8, _hoisted_12)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_14, [_createElementVNode("h3", {
            class: "data-table-cell-title cursor-pointer truncate hover:text-primary-600",
            onClick: $event => openDetailModal(item)
          }, _toDisplayString(item.title), 9, _hoisted_15), item.isTop ? (_openBlock(), _createElementBlock("span", _hoisted_16, "置顶")) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass([statusClass(item.status), "shrink-0"])
          }, _toDisplayString(statusText(item.status)), 3)]), item.summary ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(item.summary), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, [_cache[43] || (_cache[43] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
          })], -1)), _createTextVNode(" " + _toDisplayString(_unref(getLastCategoryName)(item.categoryId)), 1)]), _createElementVNode("span", _hoisted_20, [_cache[44] || (_cache[44] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)), _createTextVNode(" " + _toDisplayString(item.viewCount || 0), 1)]), _createElementVNode("span", _hoisted_21, [_cache[45] || (_cache[45] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)), _createTextVNode(" " + _toDisplayString(item.createTime || '-'), 1)])])]), _createElementVNode("div", _hoisted_22, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openFormModal(item),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[46] || (_cache[46] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_23)), [[_directive_permission, 'kb:article:edit']]), _createElementVNode("button", {
            onClick: $event => openMpPreview(item.id),
            class: "table-action-button is-teal",
            title: "小程序预览",
            "aria-label": "小程序预览"
          }, [...(_cache[47] || (_cache[47] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          })], -1)]))], 8, _hoisted_24), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => toggleMoreMenu(item.id, $event),
            class: "more-menu-container table-action-button is-neutral",
            title: "更多",
            "aria-label": "更多"
          }, [...(_cache[48] || (_cache[48] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
          })], -1)]))], 8, _hoisted_25)), [[_directive_permission, 'kb:article:edit']])])]);
        }), 128))]))])]), articleList.value.length ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pageInfo,
          size: pageSize.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "size"])) : _createCommentVNode("", true)])])]), _createVNode(_Transition, {
          name: "modal"
        }, {
          default: _withCtx(() => [_createVNode(AppModal, {
            visible: _unref(showCategoryModal),
            size: "md",
            "panel-class": "ring-1 ring-black/5",
            onClose: _unref(closeCategoryModal)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_cache[52] || (_cache[52] = _createElementVNode("div", {
              class: "absolute inset-0 bg-grid-white/10"
            }, null, -1)), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_cache[50] || (_cache[50] = _createElementVNode("div", {
              class: "flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 text-white"
            }, [_createElementVNode("svg", {
              class: "h-5 w-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
            })])], -1)), _createElementVNode("div", null, [_createElementVNode("h3", _hoisted_29, _toDisplayString(_unref(isCategoryEdit) ? '编辑分类' : '新增分类'), 1), _cache[49] || (_cache[49] = _createElementVNode("p", {
              class: "mt-0.5 text-sm text-primary-100"
            }, "资讯分类管理", -1))])]), _createElementVNode("button", {
              onClick: _cache[9] || (_cache[9] = (...args) => _unref(closeCategoryModal) && _unref(closeCategoryModal)(...args)),
              class: "cursor-pointer rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
            }, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
              class: "h-5 w-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_cache[53] || (_cache[53] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
            })]), _createTextVNode(" 分类名称 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(categoryForm).name = $event),
              class: "form-input",
              placeholder: "请输入分类名称"
            }, null, 512), [[_vModelText, _unref(categoryForm).name]])]), _createElementVNode("div", _hoisted_32, [_cache[54] || (_cache[54] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
            })]), _createTextVNode(" 上级分类 ")], -1)), _createVNode(_component_el_select, {
              modelValue: _unref(categoryForm).parentId,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(categoryForm).parentId = $event),
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "顶级分类",
                value: 0
              }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flatCategories), cat => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: cat.id,
                  label: cat.label,
                  value: cat.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]), _cache[60] || (_cache[60] = _createElementVNode("div", {
              class: "mx-6 border-t border-dashed border-slate-200"
            }, null, -1)), _createElementVNode("div", _hoisted_33, [_cache[59] || (_cache[59] = _createElementVNode("p", {
              class: "text-xs font-medium text-slate-400 uppercase tracking-wider"
            }, "可选信息", -1)), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_cache[55] || (_cache[55] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
            })]), _createTextVNode(" 排序号 ")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(categoryForm).sort = $event),
              type: "number",
              class: "form-input",
              placeholder: "0"
            }, null, 512), [[_vModelText, _unref(categoryForm).sort, void 0, {
              number: true
            }]])]), _createElementVNode("div", _hoisted_36, [_cache[56] || (_cache[56] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            })]), _createTextVNode(" 状态 ")], -1)), _createVNode(_component_el_select, {
              modelValue: _unref(categoryForm).status,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(categoryForm).status = $event),
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "启用",
                value: 0
              }), _createVNode(_component_el_option, {
                label: "停用",
                value: 1
              })]),
              _: 1
            }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_37, [_cache[57] || (_cache[57] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
            })]), _createTextVNode(" 备注 ")], -1)), _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(categoryForm).remark = $event),
              rows: "2",
              class: "form-textarea",
              placeholder: "可选备注信息"
            }, null, 512), [[_vModelText, _unref(categoryForm).remark]]), _cache[58] || (_cache[58] = _createElementVNode("p", {
              class: "form-helper"
            }, "填写备注有助于分类管理", -1))])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("button", {
              onClick: _cache[15] || (_cache[15] = (...args) => _unref(closeCategoryModal) && _unref(closeCategoryModal)(...args)),
              class: "btn-secondary"
            }, "取消"), _createElementVNode("button", {
              onClick: _cache[16] || (_cache[16] = (...args) => _unref(submitCategory) && _unref(submitCategory)(...args)),
              class: "btn-primary hover:shadow-md hover:shadow-primary-500/30"
            }, _toDisplayString(_unref(isCategoryEdit) ? '保存修改' : '创建分类'), 1)])]),
            _: 1
          }, 8, ["visible", "onClose"])]),
          _: 1
        }), _createVNode(AppModal, {
          visible: showFormModal.value,
          size: "4xl",
          "panel-class": "ring-1 ring-black/5",
          onClose: closeFormModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_cache[63] || (_cache[63] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_cache[61] || (_cache[61] = _createElementVNode("div", {
            class: "flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 text-white"
          }, [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
          })])], -1)), _createElementVNode("div", null, [_createElementVNode("h3", _hoisted_42, _toDisplayString(isEdit.value ? '编辑资讯' : '新增资讯'), 1), _createElementVNode("p", _hoisted_43, _toDisplayString(isEdit.value ? '修改资讯内容' : '创建新的资讯内容'), 1)])]), _createElementVNode("button", {
            onClick: closeFormModal,
            class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[62] || (_cache[62] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_cache[64] || (_cache[64] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, [_createTextVNode("资讯标题 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => articleForm.title = $event),
            class: "form-input",
            placeholder: "请输入资讯标题"
          }, null, 512), [[_vModelText, articleForm.title]])]), _createElementVNode("div", _hoisted_48, [_cache[65] || (_cache[65] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "所属分类", -1)), _createVNode(_component_el_select, {
            modelValue: articleForm.categoryId,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => articleForm.categoryId = $event),
            class: "form-select"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "请选择分类",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flatCategories), cat => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: cat.id,
                label: cat.label,
                value: cat.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_49, [_cache[66] || (_cache[66] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "作者", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => articleForm.author = $event),
            class: "form-input",
            placeholder: "请输入文章作者"
          }, null, 512), [[_vModelText, articleForm.author]])]), _createElementVNode("div", _hoisted_50, [_cache[67] || (_cache[67] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "摘要", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => articleForm.summary = $event),
            rows: "2",
            class: "form-textarea",
            placeholder: "简短描述资讯内容，用于列表展示"
          }, null, 512), [[_vModelText, articleForm.summary]])]), _createElementVNode("div", _hoisted_51, [_cache[71] || (_cache[71] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "封面图", -1)), _createElementVNode("div", _hoisted_52, [coverDisplayUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("img", {
            src: coverDisplayUrl.value,
            class: "h-full w-full object-cover"
          }, null, 8, _hoisted_54), _createElementVNode("div", _hoisted_55, [_createElementVNode("button", {
            onClick: _cache[21] || (_cache[21] = $event => showCoverPreview.value = true),
            class: "flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-white transition-colors hover:bg-white/40",
            title: "查看大图"
          }, [...(_cache[68] || (_cache[68] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
          })], -1)]))]), _createElementVNode("button", {
            onClick: removeCover,
            class: "flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-white transition-colors hover:bg-red-500/80",
            title: "删除封面"
          }, [...(_cache[69] || (_cache[69] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))])])])) : _createCommentVNode("", true), !coverDisplayUrl.value ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: triggerCoverUpload,
            class: "flex h-24 w-40 cursor-pointer flex-col items-center justify-center gap-1.5 rounded-lg border-2 border-dashed border-slate-200 text-slate-400 transition-colors hover:border-primary-300 hover:text-primary-500"
          }, [...(_cache[70] || (_cache[70] = [_createElementVNode("svg", {
            class: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1), _createElementVNode("span", {
            class: "text-xs"
          }, "上传封面", -1)]))])) : _createCommentVNode("", true), _createElementVNode("input", {
            ref_key: "coverInput",
            ref: coverInput,
            type: "file",
            accept: "image/*",
            class: "hidden",
            onChange: handleCoverUpload
          }, null, 544)])]), _createElementVNode("div", _hoisted_56, [_cache[72] || (_cache[72] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, [_createTextVNode("资讯内容 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(RichTextEditor, {
            modelValue: articleForm.content,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => articleForm.content = $event),
            placeholder: "请输入资讯内容...",
            "min-height": "300px",
            "upload-module": "article"
          }, null, 8, ["modelValue"])])])]), _createElementVNode("div", {
            class: "flex justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4 shrink-0"
          }, [_createElementVNode("button", {
            onClick: openFormMpPreview,
            class: "rounded-lg border border-primary-200 px-4 py-2 text-sm text-primary-700 hover:bg-primary-50"
          }, "预览小程序效果"), _createElementVNode("button", {
            onClick: closeFormModal,
            class: "cursor-pointer rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 hover:text-slate-900"
          }, "取消"), _createElementVNode("button", {
            onClick: submitArticle,
            class: "cursor-pointer rounded-lg bg-primary-700 px-5 py-2 text-sm font-medium text-white shadow-sm shadow-primary-600/30 transition-all hover:bg-primary-800 hover:shadow-md hover:shadow-primary-600/40"
          }, "保存")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDetailModal.value,
          size: "3xl",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[24] || (_cache[24] = $event => showDetailModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_57, [_cache[75] || (_cache[75] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_58, [_cache[74] || (_cache[74] = _createElementVNode("div", {
            class: "flex items-center gap-3"
          }, [_createElementVNode("div", {
            class: "flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 text-white"
          }, [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
          })])]), _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-white"
          }, "资讯详情"), _createElementVNode("p", {
            class: "mt-0.5 text-sm text-primary-100"
          }, "查看资讯详细内容")])], -1)), _createElementVNode("button", {
            onClick: _cache[23] || (_cache[23] = $event => showDetailModal.value = false),
            class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[73] || (_cache[73] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_59, [detailLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_60, [...(_cache[76] || (_cache[76] = [_createElementVNode("div", {
            class: "h-8 w-3/4 rounded-lg bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "h-5 w-1/2 rounded bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "h-40 rounded-xl bg-slate-200"
          }, null, -1)]))])) : detailData.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [detailData.value.coverImage ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("img", {
            src: getImageUrl(detailData.value.coverImage),
            alt: detailData.value.title,
            class: "w-full max-h-64 object-cover"
          }, null, 8, _hoisted_62)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_63, [_createElementVNode("span", {
            class: _normalizeClass(statusClass(detailData.value.status))
          }, _toDisplayString(statusText(detailData.value.status)), 3), detailData.value.isTop ? (_openBlock(), _createElementBlock("span", _hoisted_64, [...(_cache[77] || (_cache[77] = [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "currentColor",
            viewBox: "0 0 20 20"
          }, [_createElementVNode("path", {
            d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          })], -1), _createTextVNode(" 置顶 ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("h2", _hoisted_65, _toDisplayString(detailData.value.title), 1), detailData.value.summary ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(detailData.value.summary), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_cache[78] || (_cache[78] = _createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)), _createTextVNode(" 浏览 " + _toDisplayString(detailData.value.viewCount || 0) + " 次 ", 1)]), _createElementVNode("div", _hoisted_69, [_cache[79] || (_cache[79] = _createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
          })], -1)), _createTextVNode(" " + _toDisplayString(_unref(getCategoryName)(detailData.value.categoryId)), 1)])]), _createElementVNode("div", _hoisted_70, [_cache[80] || (_cache[80] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900 mb-3"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6h16M4 12h16M4 18h7"
          })])]), _createTextVNode(" 资讯内容 ")], -1)), _createElementVNode("div", _hoisted_71, [_withDirectives(_createElementVNode("div", _hoisted_72, null, 512), [[_directive_safe_html, detailData.value.content]])])]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_cache[81] || (_cache[81] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1)), _createTextVNode(" 创建者：" + _toDisplayString(detailData.value.createBy || '-'), 1)]), _createElementVNode("div", _hoisted_75, [_cache[82] || (_cache[82] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)), _createTextVNode(" 创建：" + _toDisplayString(_unref(formatDateTimeText)(detailData.value.createTime)), 1)]), _createElementVNode("div", _hoisted_76, [_cache[83] || (_cache[83] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createTextVNode(" 更新：" + _toDisplayString(_unref(formatDateTimeText)(detailData.value.updateTime)), 1)]), detailData.value.publishTime ? (_openBlock(), _createElementBlock("div", _hoisted_77, [_cache[84] || (_cache[84] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createTextVNode(" 发布：" + _toDisplayString(_unref(formatDateTimeText)(detailData.value.publishTime)), 1)])) : _createCommentVNode("", true)])], 64)) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showCoverPreview.value,
          size: "none",
          "panel-class": "max-w-[90vw]",
          "z-index": 60,
          onClose: _cache[26] || (_cache[26] = $event => showCoverPreview.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_78, [_createElementVNode("img", {
            src: coverDisplayUrl.value,
            class: "max-h-[90vh] max-w-[90vw] rounded-lg object-contain shadow-2xl"
          }, null, 8, _hoisted_79), _createElementVNode("button", {
            onClick: _cache[25] || (_cache[25] = $event => showCoverPreview.value = false),
            class: "absolute -right-3 -top-3 flex h-8 w-8 items-center justify-center rounded-full bg-white text-slate-600 shadow-lg transition-colors hover:bg-slate-100"
          }, [...(_cache[85] || (_cache[85] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showConfirmModal.value,
          size: "sm",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[28] || (_cache[28] = $event => showConfirmModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_cache[86] || (_cache[86] = _createElementVNode("div", {
            class: "flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-red-600"
          }, [_createElementVNode("svg", {
            class: "h-7 w-7",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          })])], -1)), _cache[87] || (_cache[87] = _createElementVNode("h3", {
            class: "mt-4 text-lg font-semibold text-slate-900"
          }, "确认删除", -1)), _createElementVNode("p", _hoisted_81, _toDisplayString(confirmMessage.value), 1)]), _createElementVNode("div", _hoisted_82, [_createElementVNode("button", {
            onClick: _cache[27] || (_cache[27] = $event => showConfirmModal.value = false),
            class: "flex-1 cursor-pointer rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 hover:text-slate-900"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDeleteAction,
            class: "flex-1 cursor-pointer rounded-lg bg-red-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm shadow-red-600/30 transition-all hover:bg-red-700 hover:shadow-md hover:shadow-red-600/40"
          }, "删除")])]),
          _: 1
        }, 8, ["visible"]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [openMoreId.value !== null ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed z-[9999] w-40 overflow-hidden rounded-xl border border-slate-200 bg-white py-1.5 shadow-xl ring-1 ring-black/5",
          style: _normalizeStyle(moreMenuStyle.value),
          onClick: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"]))
        }, [openMoreItem.value?.status === 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[29] || (_cache[29] = $event => handlePublish(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-xs text-slate-700 transition-colors hover:bg-slate-50"
        }, [...(_cache[88] || (_cache[88] = [_createElementVNode("svg", {
          class: "h-4 w-4 text-emerald-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1), _createTextVNode(" 发布 ", -1)]))])), [[_directive_permission, 'kb:article:edit']]) : _createCommentVNode("", true), openMoreItem.value?.status === 1 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[30] || (_cache[30] = $event => handleOffline(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-xs text-slate-700 transition-colors hover:bg-slate-50"
        }, [...(_cache[89] || (_cache[89] = [_createElementVNode("svg", {
          class: "h-4 w-4 text-amber-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
        })], -1), _createTextVNode(" 下架 ", -1)]))])), [[_directive_permission, 'kb:article:edit']]) : _createCommentVNode("", true), openMoreItem.value?.status === 2 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 2,
          onClick: _cache[31] || (_cache[31] = $event => handleOnline(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-xs text-slate-700 transition-colors hover:bg-slate-50"
        }, [...(_cache[90] || (_cache[90] = [_createElementVNode("svg", {
          class: "h-4 w-4 text-emerald-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1), _createTextVNode(" 上架 ", -1)]))])), [[_directive_permission, 'kb:article:edit']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[32] || (_cache[32] = $event => handleToggleTop(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-xs text-slate-700 transition-colors hover:bg-slate-50"
        }, [_cache[91] || (_cache[91] = _createElementVNode("svg", {
          class: "h-4 w-4 text-amber-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 15l7-7 7 7"
        })], -1)), _createTextVNode(" " + _toDisplayString(openMoreItem.value?.isTop ? '取消置顶' : '置顶'), 1)])), [[_directive_permission, 'kb:article:edit']]), _cache[93] || (_cache[93] = _createElementVNode("div", {
          class: "my-1 border-t border-slate-100"
        }, null, -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[33] || (_cache[33] = $event => confirmDeleteArticle(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-xs text-red-600 transition-colors hover:bg-red-50"
        }, [...(_cache[92] || (_cache[92] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })], -1), _createTextVNode(" 删除 ", -1)]))])), [[_directive_permission, 'kb:article:edit']])], 4)) : _createCommentVNode("", true)])), _createVNode(ArticlePreviewModal, {
          modelValue: showMpPreviewModal.value,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => showMpPreviewModal.value = $event),
          "article-id": previewArticleId.value,
          "preview-data": previewArticleData.value
        }, null, 8, ["modelValue", "article-id", "preview-data"])]),
        _: 1
      });
    };
  }
};